import { z } from 'zod';
import { WorkflowSchema } from './recipes.js';
export const ShareRequestSchema = z.object({ username: z.string().trim().min(1, 'Required').max(64) });
export const RecipeShareSchema = z.object({ username: z.string(), displayName: z.string(), createdAt: z.string() });
export const RecipeSharesResponseSchema = z.object({ shares: z.array(RecipeShareSchema) });
export const RecipeShareResponseSchema = z.object({ share: RecipeShareSchema });
/** What a recipient sees: the recipe text, never the owner's machine, runs or images (doc 30). */
export const SharedRecipeSchema = z.object({
    id: z.string(),
    title: z.string(),
    intent: z.string().nullable(),
    notes: z.string().nullable(),
    family: z.string().nullable(),
    sharedBy: z.object({ username: z.string(), displayName: z.string() }),
    sharedAt: z.string(),
    updatedAt: z.string(),
});
export const SharedRecipesResponseSchema = z.object({ recipes: z.array(SharedRecipeSchema) });
export const SharedRecipeDetailSchema = z.object({ recipe: SharedRecipeSchema, workflow: WorkflowSchema });
export const CopySharedRequestSchema = z.object({ machineId: z.string().min(1).max(64).optional() });
//# sourceMappingURL=sharing.js.map